<app-only-table-generator
    [tableInput]="tableGenInput"
    [tableData]="tableData"
></app-only-table-generator>
